import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["gridAreaNames", "children", "scrollContainerMarginInline", "scrollContainerScrollPaddingInline"];
import styled from 'foundations-theming/utils';
import { PPUIGrid } from 'pricing-pages-ui-components/grid/PPUIGrid';
import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const ScrollContainer = styled.div.withConfig({
  displayName: "MerchCardGridLayout__ScrollContainer"
})(({
  theme,
  $marginInline,
  $scrollPaddingInline
}) => {
  return Object.assign({
    overflowX: 'auto',
    scrollSnapType: 'x mandatory',
    scrollbarWidth: 'none',
    // Prevents absolute positioned content & box shadow from being clipped when it flows outside this ScrollContainer
    paddingBlock: theme.space[1000],
    marginBlock: `-${theme.space[1000]}`
  }, $marginInline !== undefined && {
    marginInline: $marginInline
  }, $scrollPaddingInline !== undefined && {
    scrollPaddingInline: $scrollPaddingInline
  }, {
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  });
});
const MerchCardGridLayoutContext = /*#__PURE__*/createContext(null);
export const useMerchCardGridLayout = () => {
  const context = useContext(MerchCardGridLayoutContext);
  if (!context) {
    throw new Error('useMerchCardGridLayout must be used within a MerchCardGridLayout');
  }
  return context;
};
/** @description This component provides a context for the layout of merch card
 * grid. It uses a grid layout to arrange the sections of the merch card
 * according to the specified order. The `gridAreaNames` prop defines the
 * sequence of sections, and the children prop allows for rendering the content
 * of each section within the grid.
 *
 * NOTE: Avoid direct styling; Styling should be handled by the consumer
 */

export const MerchCardGridLayout = _ref => {
  let {
      gridAreaNames,
      children,
      scrollContainerMarginInline,
      scrollContainerScrollPaddingInline
    } = _ref,
    gridProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(MerchCardGridLayoutContext.Provider, {
    value: {
      gridAreaNames: gridAreaNames.filter(section => section !== '.')
    },
    children: /*#__PURE__*/_jsx(ScrollContainer, {
      $marginInline: scrollContainerMarginInline,
      $scrollPaddingInline: scrollContainerScrollPaddingInline,
      children: /*#__PURE__*/_jsx(PPUIGrid, Object.assign({
        gridTemplateAreas: gridAreaNames.map(section => `"${section}"`).join('\n')
      }, gridProps, {
        children: children
      }))
    })
  });
};